export default "__VITE_ASSET__Cv5Gx6$Y__"